module.exports = __webpack_public_path__ + "static/foxPortal-49e4e8bf28e66abb5b154a0adc7c29b3.jpg";